var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 291,
    viewBox: "0 0 140 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3861 36.7593C60.4779 39.1702 78.0281 37.3007 78.5776 32.5503C79.1271 27.7998 62.4438 21.9995 41.352 19.5886C20.2602 17.1777 2.70993 19.0472 2.16042 23.7976C1.62199 28.5158 18.2943 34.3484 39.3861 36.7593Z",
    fill: "url(#paint0_linear_23_4911)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4434 36.3824C58.4129 38.5694 74.2148 36.8567 74.7061 32.591C75.1973 28.3253 60.191 23.1007 41.2214 20.9138C22.2519 18.7268 6.44996 20.4395 5.95873 24.7052C5.43525 28.9599 20.4416 34.1844 39.4434 36.3824Z",
    fill: "url(#paint1_linear_23_4911)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5017 35.8977C58.1265 38.0384 73.6796 36.4205 74.7191 32.3431C74.7292 32.4186 74.7393 32.4942 74.7061 32.591C74.2148 36.8567 58.4129 38.5693 39.4434 36.3824C20.4739 34.1954 5.46748 28.9709 5.95872 24.7052C5.94861 24.6296 5.98183 24.5328 6.00398 24.4683C6.07401 28.6744 20.8445 33.7459 39.5017 35.8977Z",
    fill: "#A86314"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1382 27.7676L78.5776 32.5503C79.1271 27.7998 62.4438 21.9995 41.352 19.5886C20.2602 17.1777 2.70996 19.0472 2.16045 23.7976L2.72103 19.0149C3.27053 14.2645 20.8208 12.395 41.9126 14.8059C63.0044 17.2168 79.6555 23.0061 79.1382 27.7676Z",
    fill: "url(#paint2_linear_23_4911)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0807 214.698C9.51698 227.974 5.14547 250.051 16.3207 264.019C27.507 277.954 49.9958 278.501 66.5705 265.193C83.1342 251.917 87.5057 229.84 76.3305 215.872C65.1442 201.937 42.6443 201.422 26.0807 214.698Z",
    fill: "url(#paint3_linear_23_4911)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1282 217.239C13.2046 229.204 9.3059 249.064 19.3399 261.63C29.4173 274.175 49.6528 274.67 64.5765 262.705C79.5001 250.741 83.3988 230.881 73.3648 218.315C63.2552 205.758 43.0196 205.264 28.1282 217.239Z",
    fill: "url(#paint4_linear_23_4911)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9681 268.516L16.3529 264.03C27.5392 277.965 50.028 278.512 66.6027 265.204C83.1664 251.928 87.5379 229.851 76.3627 215.883L79.9779 220.369C91.1642 234.304 86.7927 256.381 70.2179 269.69C53.6432 282.998 31.1433 282.483 19.9681 268.516Z",
    fill: "url(#paint5_linear_23_4911)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7039 217.978C13.9324 229.814 9.94993 249.393 19.6494 261.989C19.5426 261.88 19.4468 261.739 19.3399 261.63C9.26256 249.085 13.2046 229.204 28.1282 217.239C43.0519 205.275 63.2874 205.769 73.3648 218.315C73.4606 218.456 73.5674 218.564 73.6632 218.705C63.464 206.515 43.4754 206.141 28.7039 217.978Z",
    fill: "#7E470D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.956 93.3742C121.978 96.3021 138.518 102.522 137.86 107.271C137.203 112.021 119.624 113.448 98.5697 110.509C77.5473 107.581 61.0189 101.329 61.6652 96.6119C62.3225 91.8624 79.9122 90.403 100.956 93.3742Z",
    fill: "url(#paint6_linear_23_4911)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.899 93.7511C119.821 96.3906 134.694 102.002 134.095 106.267C133.496 110.532 117.655 111.834 98.7325 109.195C79.8101 106.555 64.9366 100.944 65.5357 96.679C66.1458 92.382 81.9873 91.0795 100.899 93.7511Z",
    fill: "url(#paint7_linear_23_4911)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.851 94.2036C119.429 96.7968 134.078 102.223 134.061 106.471C134.083 106.407 134.116 106.31 134.106 106.235C134.705 101.97 119.832 96.3583 100.91 93.7188C81.9872 91.0794 66.1458 92.382 65.5467 96.6467C65.5246 96.7112 65.5236 96.819 65.5337 96.8946C66.6811 92.8181 82.2736 91.6104 100.851 94.2036Z",
    fill: "#7E470D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.171 112.01L137.828 107.26C137.171 112.01 119.592 113.437 98.5374 110.498C77.515 107.57 60.9867 101.318 61.6329 96.6009L60.9756 101.35C60.3183 106.1 76.8254 112.308 97.8801 115.247C118.935 118.186 136.513 116.759 137.171 112.01Z",
    fill: "url(#paint8_linear_23_4911)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_4911",
    x1: 41.3874,
    y1: 19.3105,
    x2: 39.2272,
    y2: 38.1535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_4911",
    x1: 41.5692,
    y1: 9.41389,
    x2: 39.6624,
    y2: 38.7103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23_4911",
    x1: 81.321,
    y1: 26.0788,
    x2: -1.73768,
    y2: 16.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23_4911",
    x1: 37.4171,
    y1: 228.838,
    x2: 63.6696,
    y2: 261.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23_4911",
    x1: 82.7341,
    y1: 285.336,
    x2: 28.8114,
    y2: 218.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23_4911",
    x1: 26.8148,
    y1: 280.067,
    x2: 85.7383,
    y2: 232.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3821,
    stopColor: "#E6B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    stopColor: "#CB9235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#B57925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#A6681B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4552,
    stopColor: "#9D5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#9F5F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6015,
    stopColor: "#AD6D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C48429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#E4A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23_4911",
    x1: 98.534,
    y1: 114.288,
    x2: 101.679,
    y2: 82.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_23_4911",
    x1: 105.292,
    y1: 62.3398,
    x2: 97.7887,
    y2: 116.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_23_4911",
    x1: 138.882,
    y1: 114.189,
    x2: 56.0845,
    y2: 102.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3821,
    stopColor: "#E6B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    stopColor: "#CB9235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#B57925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#A6681B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4552,
    stopColor: "#9D5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#9F5F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6015,
    stopColor: "#AD6D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C48429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#E4A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin4);
export default __webpack_public_path__ + "static/media/coin4.3848105ef15f5d857372a66adc1d6b99.svg";
export { ForwardRef as ReactComponent };